import { FC } from "react";
import techMan from "../../Assets/TalentOnDemand/tech-man.png";
import bgImage from "../../Assets/TalentOnDemand/window-bg.png";

const TalentOnDemandTechQuotes: FC = () => {
    return (
        <section
            className="w-full pt-20 bg-cover bg-center bg-no-repeat"
            style={{
                backgroundImage: `url(${bgImage})`,
            }}
        >
            <div className="max-w-[1400px] px-6 mx-auto flex flex-col lg:flex-row items-center lg:justify-evenly lg:gap-10">
                {/* LEFT: Quote Text */}
                <div className="max-w-2xl text-white text-xl italic leading-relaxed mb-20">
                    “I'm committed to maintaining a strong Private Talent Community. By providing quick access to qualified and available talent, we can help our customers significantly reduce the time and effort it takes to find the right fit.”
                </div>

                {/* RIGHT: Image */}
                <img
                    src={techMan}
                    alt="Tech Expert"
                    className="w-full h-auto mt-auto object-contain max-w-[500px]"
                />
            </div>
        </section>
    );
};

export default TalentOnDemandTechQuotes;
